<template>
  <div class="app-header">
    <div class="toolbar" :class="{'smaller-toolbar': small}">
      <!-- <language-select
        class="language-select"
        :style="getLanguageStyle"
        @changeLanguage="changeLanguage"
      /> -->
      <navigation-menu class="menu" :user="user" :isUserSet="isUserSet" :isAdmin="isAdmin" />
    </div>
  </div>
</template>

<script>
// import LanguageSelect from "./language-select.vue";
import NavigationMenu from "./NavigationMenu.vue";
// @ is an alias to /src
export default {
  name: "app-header",
  props: ["small"],
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push({ name: "login" }).catch(() => {});
    }
  },
  data() {
    return {
      user: this.$session.get("user")
    };
  },
  computed: {
    isUserSet() {
      if (this.user == null) {
        return false;
      }
      return true;
    },

    isAdmin() {
      if (this.user == null) {
        return false;
      }
      return this.user["type"] in [0, 1];
    },

    getLanguageStyle() {
      if (this.isUserSet) {
        return {
          top: "7px",
          right: "100px"
        };
      } else {
        return {
          top: "5px",
          left: "10px"
        };
      }
    },

    userType() {
      if (this.user == null) {
        return false;
      }
      switch (this.user["type"]) {
        case 0:
          return this.$t("header.super");
        case 1:
          return this.$t("header.admin");
        case 2:
          return this.$t("header.planner");
        case 3:
          return this.$t("header.manager");
        case 4:
          return this.$t("header.packer");
        default:
          return this.$t("header.simple_user");
      }
    }
  },
  methods: {
    changeLanguage(language) {
      if (this.$router.currentRoute.params.lang != language) {
        let pathParts = this.$router.currentRoute.fullPath.split("/");
        let redirectPath = language;
        for (let i = 2; i < pathParts.length; i++)
          redirectPath += "/" + pathParts[i];
        this.$router.push({ path: `/${redirectPath}` }).catch(() => {});
        this.$router.go();
      }
    }
  },
  components: {
    // LanguageSelect,
    NavigationMenu
  }
};
</script>

<style scoped>
.toolbar {
  position: relative;
  width: 100%;
  height: 70px;
  background-color: rgb(25, 118, 210);
}
.language-select {
  position: absolute;
}
.menu {
  position: absolute;
  right: 0;
  width: calc(100%);
}
.smaller-toolbar {
  height: 40px;
}
.app-header{
  box-shadow: 0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19) !important;
}
</style>
